import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig, ErrorHandler, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';

import { EnvironmentService } from '@core/config/environment.service';
import { authSessionInitializer } from '@core/config/auth-session.initializer';
import { runtimeConfigInitializer } from '@core/config/runtime-config.initializer';
import { themeInitializer } from '@core/ui/theme.initializer';
import { ThemeService } from '@core/ui/theme.service';
import { IdleSessionService } from '@core/auth/idle-session.service';
import { GlobalErrorHandler } from '@core/handlers/global-error.handler';
import { authInterceptor } from '@core/interceptors/auth.interceptor';
import { httpErrorInterceptor } from '@core/interceptors/error.interceptor';
import { loadingInterceptor } from '@core/interceptors/loading.interceptor';

import { AuthService } from '@core/auth/auth.service';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([loadingInterceptor, authInterceptor, httpErrorInterceptor])),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    {
      provide: APP_INITIALIZER,
      useFactory: runtimeConfigInitializer,
      deps: [EnvironmentService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: authSessionInitializer,
      deps: [AuthService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => undefined,
      deps: [IdleSessionService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: themeInitializer,
      deps: [ThemeService],
      multi: true,
    },
  ],
};
